import io from 'socket.io-client'

export const socketNotifications = io.connect(process.env.REACT_APP_NOTIFICATIONS || '', {
  path: process.env.REACT_APP_NOTIFICATIONS_PATH || '/socket.io',
})

socketNotifications.on('connect_error', (err: any) => {
  console.log(`socket connect_error due to ${err.message}`)
})
